import {
    apiFolioReenviarOrderCorreo,
    apiPromocionesOBtenerCuponAutocompletar,
    apiReportesVentasDescargar,
    apiReportesVentasMeditoc,
} from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnHandleChangeDate, fnHandleChangeText } from "../settings/handleConfig";
import { getFormFiltro, getModelOrden } from "../models/ReporteVentaModel";
import { green, red } from "@material-ui/core/colors";

import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import { EnumStatusConekta } from "../settings/enumConfig";
import { format } from "date-fns";
import { useLayout } from "./LayoutContext";
import { useRequest } from "./RequestContext";

export const ReporteVentaContext = createContext();

export function ReporteVentaProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { Get, GetFile, Post } = useRequest();

    const [reporteVenta, setReporteVenta] = useState(false);
    const [ordenSeleccionada, setOrdenSeleccionada] = useState(getModelOrden());
    const [listaCupones, setListaCupones] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);

    const [modalOpenDetalleOrden, setModalOpenDetalleOrden] = useState(false);

    const [formFiltro, setFormFiltro] = useState(getFormFiltro());
    const [resumenVentasConekta, setResumenVentasConekta] = useState(null);
    const [resumenVentasAdmin, setResumenVentasAdmin] = useState(null);

    const handleOpenDetalleOrden = (value) => {
        setModalOpenDetalleOrden(value);
    };

    const handleChangeTanIndex = (value) => {
        setTabIndex(value);
    };

    const handleChangeOrdenSeleccionada = (value) => {
        setOrdenSeleccionada(value);
    };

    const handleChangeFormFiltroText = fnHandleChangeText(formFiltro, setFormFiltro);
    const handleChangeFormFiltroDate = fnHandleChangeDate(formFiltro, setFormFiltro);
    const handleChangeFormFiltroCupon = (e, value) => {
        const { txtCupon } = formFiltro;
        setFormFiltro({ ...formFiltro, txtCupon: { ...txtCupon, value } });
    };

    const handleClickFiltrarVentas = () => {
        fnObtenerReporteVenta(
            formFiltro.txtFolio.value,
            formFiltro.txtFolioEmpresa.value,
            formFiltro.txtOrigen.value,
            formFiltro.txtOrden.value,
            formFiltro.txtEstatus.value,
            !formFiltro.txtCupon.value ? "" : formFiltro.txtCupon.value,
            formFiltro.txtTipoPago.value,
            !formFiltro.txtFechaDe.value ? null : formFiltro.txtFechaDe.value.toISOString(),
            !formFiltro.txtFechaA.value ? null : formFiltro.txtFechaA.value.toISOString()
        );
    };

    const handleClickRefrescarDatos = async () => {
        setFormFiltro(getFormFiltro());
        await fnObtenerReporteVenta();
        await fnObtenerCupones();
    };

    const handleClickDescargarReporte = () => {
        fnDescargarReporteVentas(
            formFiltro.txtFolio.value,
            formFiltro.txtFolioEmpresa.value,
            formFiltro.txtOrigen.value,
            formFiltro.txtOrden.value,
            formFiltro.txtEstatus.value,
            !formFiltro.txtCupon.value ? "" : formFiltro.txtCupon.value,
            formFiltro.txtTipoPago.value,
            !formFiltro.txtFechaDe.value ? null : formFiltro.txtFechaDe.value.toISOString(),
            !formFiltro.txtFechaA.value ? null : formFiltro.txtFechaA.value.toISOString()
        );
    };

    const handleClickDetalleOrden = (orden) => {
        // console.log(orden);
        setOrdenSeleccionada(orden);
        setModalOpenDetalleOrden(true);
    };

    const handleClickReenviarCorreo = () => {
        if (ordenSeleccionada.sOrderId === "") {
            handleOpenAlert("No hay una orden seleccionada para reenviar el correo");
            return;
        }

        fnReenviarCorreoOrden(ordenSeleccionada.sOrderId);
    };

    const fnProcesarOrdenesConekta = (ResumenOrdenes) => {
        const resumen = {
            ...ResumenOrdenes,
            lstOrdenes: ResumenOrdenes.lstOrdenes.map((orden) => ({
                ...orden,
                nAmount: "$" + orden.nAmount.toLocaleString("en", { minimumFractionDigits: 2 }),
                nAmountDiscount: "$" + orden.nAmountDiscount.toLocaleString("en", { minimumFractionDigits: 2 }),
                nAmountTax: "$" + orden.nAmountTax.toLocaleString("en", { minimumFractionDigits: 2 }),
                nAmountPaid: "$" + orden.nAmountPaid.toLocaleString("en", { minimumFractionDigits: 2 }),
                sPaymentStatusWI: (
                    <span>
                        {orden.sPaymentStatus}
                        {orden.sPaymentStatus === EnumStatusConekta.Declined ? (
                            <CloseIcon style={{ color: red[500], verticalAlign: "middle" }} />
                        ) : (
                            <DoneIcon style={{ color: green[500], verticalAlign: "middle" }} />
                        )}
                    </span>
                ),
                sDetalle: (
                    <Button variant="contained" color="primary" onClick={() => handleClickDetalleOrden(orden)}>
                        DETALLE
                    </Button>
                ),
            })),
        };
        setResumenVentasConekta(resumen);
    };

    const fnProcesarOrdenesAdmin = (ResumenOrdenesAdmin) => {
        const resumen = {
            ...ResumenOrdenesAdmin,
            lstOrdenes: ResumenOrdenesAdmin.lstOrdenes.map((orden) => ({
                ...orden,
                nAmountPaid: "$" + orden.nAmountPaid.toLocaleString("en", { minimumFractionDigits: 2 }),
                sPaymentStatusWI: (
                    <span>
                        {orden.sPaymentStatus}
                        {orden.sPaymentStatus === EnumStatusConekta.Declined ? (
                            <CloseIcon style={{ color: red[500], verticalAlign: "middle" }} />
                        ) : (
                            <DoneIcon style={{ color: green[500], verticalAlign: "middle" }} />
                        )}
                    </span>
                ),
                sDetalle: (
                    <Button variant="contained" color="primary" onClick={() => handleClickDetalleOrden(orden)}>
                        DETALLE
                    </Button>
                ),
            })),
        };
        setResumenVentasAdmin(resumen);
    };

    const fnObtenerReporteVenta = async (
        psFolio = "",
        psIdEmpresa = "",
        psIdOrigen = "",
        psOrderId = "",
        psStatus = "",
        psCupon = "",
        psTipoPago = "",
        pdtFechaInicio = null,
        pdtFechaFinal = null
    ) => {
        const payload = {
            loader: "Consultando reporte de ventas...",
            url:
                apiReportesVentasMeditoc +
                "?psFolio=" +
                psFolio +
                "&psIdEmpresa=" +
                psIdEmpresa +
                "&psIdOrigen=" +
                psIdOrigen +
                "&psOrderId=" +
                psOrderId +
                "&psStatus=" +
                psStatus +
                "&psCupon=" +
                psCupon +
                "&psTipoPago=" +
                psTipoPago +
                "&pdtFechaInicio=" +
                pdtFechaInicio +
                "&pdtFechaFinal=" +
                pdtFechaFinal,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const { ResumenOrdenes, ResumenOrdenesAdmin } = response.Result;
            fnProcesarOrdenesConekta(ResumenOrdenes);
            fnProcesarOrdenesAdmin(ResumenOrdenesAdmin);
            setReporteVenta(true);
        }
    };

    const fnObtenerCupones = async () => {
        const payload = {
            loader: "Consultando cupones...",
            url: apiPromocionesOBtenerCuponAutocompletar,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaCupones(response.Result);
        }
    };

    const fnDescargarReporteVentas = async (
        psFolio = "",
        psIdEmpresa = "",
        psIdOrigen = "",
        psOrderId = "",
        psStatus = "",
        psCupon = "",
        psTipoPago = "",
        pdtFechaInicio = null,
        pdtFechaFinal = null
    ) => {
        const payload = {
            loader: "Descargando reporte de ventas...",
            url:
                apiReportesVentasDescargar +
                "?psFolio=" +
                psFolio +
                "&psIdEmpresa=" +
                psIdEmpresa +
                "&psIdOrigen=" +
                psIdOrigen +
                "&psOrderId=" +
                psOrderId +
                "&psStatus=" +
                psStatus +
                "&psCupon=" +
                psCupon +
                "&psTipoPago=" +
                psTipoPago +
                "&pdtFechaInicio=" +
                pdtFechaInicio +
                "&pdtFechaFinal=" +
                pdtFechaFinal,
            filename: `ReporteVentas_${format(new Date(), "yyyy-MM-dd_HH-mm-ss")}.xlsx`,
            alert: false,
        };

        await GetFile(payload);
    };

    const fnReenviarCorreoOrden = async (psOrderId) => {
        const payload = {
            loader: "Reenviando correo...",
            url: apiFolioReenviarOrderCorreo + "?psOrderId=" + psOrderId,
            body: {},
            alert: true,
        };

        await Post(payload);
    };

    return (
        <ReporteVentaContext.Provider
            value={{
                reporteVenta,
                ordenSeleccionada,
                listaCupones,
                tabIndex,
                modalOpenDetalleOrden,
                formFiltro,
                resumenVentasConekta,
                resumenVentasAdmin,
                handleOpenDetalleOrden,
                handleChangeTanIndex,
                handleChangeOrdenSeleccionada,
                handleChangeFormFiltroText,
                handleChangeFormFiltroDate,
                handleChangeFormFiltroCupon,
                handleClickFiltrarVentas,
                handleClickRefrescarDatos,
                handleClickDescargarReporte,
                handleClickDetalleOrden,
                handleClickReenviarCorreo,
            }}
        >
            {props.children}
        </ReporteVentaContext.Provider>
    );
}

export function useReporteVenta() {
    return useContext(ReporteVentaContext);
}
